import React, { useEffect, useState } from 'react'
import { useDispatch } from 'react-redux'

// components
import {
  CContainer,
  CCol,
  CRow,
} from '@coreui/react-pro'

// helpers
import Axios from '../../helpers/axios'
import { convertMoney } from '../../helpers/format-number'

const Dashboard = () => {
  const dispatch = useDispatch()

  const [dashboardCount, setDashboardCount] = useState(null);

  useEffect(() => {
    fetchMerchatDetail();
  }, []);

  const fetchMerchatDetail = () => {
    dispatch({
      type: 'SET_IS_LOADING',
      isLoading: true
    })
    Axios({
      method: "get",
      url: `/api/gamepass/v1/dashboard`
    })
      .then(({ data }) => {
        if (data) {
          setDashboardCount(data)
        }
      })
      .catch((err) => {
        console.error(err);
      })
      .finally(() => {
        dispatch({
          type: 'SET_IS_LOADING',
          isLoading: false
        })
      })
  };

  return (
    <CContainer className='px-5 py-3'>
      <h2>Dashboard</h2>
      <CRow className='mt-3 gap-5'>
        <CCol className='border border-black border-3 px-3 py-2' lg={3}>
          <CCol className='mb-2'>
            MLWDP Balance
          </CCol>
          <CCol>
            IDR {dashboardCount?.balance > 0 ? convertMoney(dashboardCount?.balance) : '0'}
          </CCol>
        </CCol>
      </CRow>
    </CContainer>
  )
}

export default Dashboard